<template>
  <div>
    <!-- Start Footer Area  -->
    <footer v-if="data.showFooter" class="rn-footer footer-style-default variation-two">
      <div v-if="data.showCta" class="rn-callto-action clltoaction-style-default style-7">
        <div class="container">
          <div class="hub-footer-grid">
            <div class="hub-footer-brand">
              <div class="inner" data-aos="fade-up">
                <div class="content text-left">
                  <Logo />
                  <p class="subtitle">
                    {{ $t('Footer.description') }}
                  </p>
                  <ul class="social-icon social-default justify-content-start">
                    <li>
                      <a href="https://www.facebook.com/GridWhiz/" target="_blank" rel="noopener">
                        <Icon name="facebook" />
                      </a>
                    </li>
                    <li>
                      <a href="https://x.com/gridwhiz" target="_blank" rel="noopener">
                        <Icon name="x" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/gridwhiz/" target="_blank" rel="noopener">
                        <Icon name="instagram" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/gridwhiz/" target="_blank" rel="noopener">
                        <Icon name="linkedin" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="footer-top hub-footer-links">
              <div class="hub-footer-link-grid">
                <div class="hub-footer-services">
                  <div class="rn-footer-widget">
                    <h4 class="title">{{ $t('Footer.Services') }}</h4>
                    <div class="inner">
                      <ul class="footer-link link-hover">
                        <li>
                          <a href="/?scrollTo=service-ev-roaming" @click.prevent="scrollToSection('service-ev-roaming')">{{ $t('Footer.evRoamingIntegration') }}</a>
                        </li>
                        <li>
                          <a href="/?scrollTo=service-clearing-house" @click.prevent="scrollToSection('service-clearing-house')">{{ $t('Footer.clearingHouse') }}</a>
                        </li>
                        <li>
                          <a href="/?scrollTo=service-consultancy" @click.prevent="scrollToSection('service-consultancy')">{{ $t('Footer.consultancy') }}</a>
                        </li>
                        <li>
                          <a href="/?scrollTo=service-platform-development" @click.prevent="scrollToSection('service-platform-development')">{{ $t('Footer.platformDevelopment') }}</a>
                        </li>
                        <!-- Pricing link hidden temporarily -->
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="hub-footer-company">
                  <div class="rn-footer-widget">
                    <h4 class="title">{{ $t('Footer.Company') }}</h4>
                    <div class="inner">
                      <ul class="footer-link link-hover">
                        <li>
                          <router-link to="/Aboutnew">{{ $t('header.about') }}</router-link>
                        </li>
                        <li>
                          <router-link to="/Blog">{{ $t('header.blog') }}</router-link>
                        </li>
                        <li>
                          <router-link to="/contact">{{ $t('header.contact') }}</router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="hub-footer-legal">
                  <div class="rn-footer-widget">
                    <h4 class="title">{{ $t('Footer.Legal') }}</h4>
                    <div class="inner">
                      <ul class="footer-link link-hover">
                        <li>
                          <router-link to="/privacy-policy">{{ $t('Footer.PrivacyPolicy') }}</router-link>
                        </li>
                        <li>
                          <router-link to="/terms-condition">{{ $t('Footer.TermsAndCondition') }}</router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Newsletter v-if="data.showNewsletter" />
    </footer>
    <!-- End Footer Area  -->

    <Copyright v-if="data.showCopyright" />

    <ScrollTop />
  </div>
</template>

<script>
import Copyright from './Copyright'
import Button from '../../elements/button/Button'
import Icon from '../../icon/Icon'
import ScrollTop from './ScrollTop'
import Logo from '../../elements/logo/Logo'
import Newsletter from './Newsletter'

export default {
  name: 'Footer',
  components: { Newsletter, Logo, ScrollTop, Icon, Button, Copyright },
  props: {
    data: {
      default: null
    }
  },
  methods: {
    scrollToSection(sectionId) {
      if (this.$route.path !== '/') {
        this.$store.commit('setScrollTarget', sectionId)
        this.$router.push({ path: '/' })
      } else {
        const element = document.getElementById(sectionId)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }
    }
  }
}
</script>
